import { combineReducers } from '@reduxjs/toolkit';
import global, { AppGlobalState } from './GlobalReducer';
import modal, { AppModalState } from './ModalReducers';
import navigationBar, { AppNavigationBar } from './NavigationBarReducer';

export type AppState = {
  global: AppGlobalState;
  modal: AppModalState;
  navigationBar: AppNavigationBar;
};

const AppReducer = combineReducers({
  global,
  modal,
  navigationBar,
});

export default AppReducer;
